import request from '@/utils/request'
import {isMeaningless} from "@/utils/common";
import Cookies from 'js-cookie'
import {Message} from "element-ui";

const PREFIX_URL = process.env.NODE_ENV === 'development' ? '' : ''

export function saveCustomColumns(data) {
    return request.put(`/base/custom`, data);
}

export function getCustomColumns(module) {
    return request.get(`/base/custom/${module}`)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

export function getDictionaryCombobox(type) {
    return request.get(`/base/dictionary/getDictionaryCombobox?type=${type}`)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

export function getCountries() {
    return request.get('/base/market/countries')
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function getMarkets() {
    return request({
        url: '/base/market/markets',
        method: 'post',
        data: {},
    })
    .then((res) => {
        return Promise.resolve(res.data);
    });
}

export function getAdMarkets() {
    return request({
        url: '/base/market/markets/ads',
        method: 'post',
        data: {},
    })
    .then((res) => {
        return Promise.resolve(res.data);
    });
}

export function getAuthCountries() {
    return request.get('/base/market/authCountries')
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function getAuthMarkets() {
    return request({
        url: '/base/market/authMarkets',
        method: 'post',
        data: {},
    })
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function getAllAuthCountries() {
    return request.get('/base/market/allAuthCountries')
      .then((res) => {
          return Promise.resolve(res.data);
      });
}

export function getAllAuthMarkets() {
    return request({
        url: '/base/market/allAuthMarkets',
        method: 'post',
        data: {},
    })
      .then((res) => {
          return Promise.resolve(res.data);
      });
}

export function getMarketTime(marketId) {
    return request.get(`/base/market/getMarketTime?marketId=${marketId}`)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function getMarket(marketId) {
    return request.get('/base/market/getMarketInfo', {
        params: {
            marketId
        }
    })
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function exportFile(url, params) {
    return request({
        method: 'post',
        url: url,
        data: params,
        responseType: 'blob'
    }).then((res) => {
        if (res.data.type === 'application/json') {
            const reader = new FileReader(); // 创建读取文件对象
            reader.readAsText(res.data, 'utf-8'); // 设置读取的数据以及返回的数据类型为utf-8
            reader.addEventListener('loadend', () => {
                const res = JSON.parse(reader.result); // 返回的数据
                Message.error(res.msg)
            });
        } else {
            downloadFile(res);
        }
        return Promise.resolve();
    })
}

export function exportCommonFile(url) {
    return request({
        method: 'get',
        url: url,
        headers: {tenant:'MDAwMA=='},
        responseType: 'blob'
    }).then((res) => {
        downloadFile(res);
        return Promise.resolve();
    })
}

export function downloadFile(resp) {
    let data = resp.data;
    // 此处提示自定义提示语，从header中获取
    // if(resp.headers['errormsg'] || !data){
    //     that.$notify.error(decodeURI(resp.headers['errormsg'])||'导出失败');
    //     return
    // }
    let url = window.URL.createObjectURL(new Blob([data]));
    let link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    // 文件名在后端设置
    let fileName = resp.headers['filename'];
    if (isMeaningless(fileName)) {
        fileName = resp.headers['content-disposition'].split(';')[1].split('=')[1];
    }
    link.setAttribute('download', decodeURI(fileName));
    document.body.appendChild(link);
    link.click()
}

export function uploadFile(params, onUploadProgress) {
    return request({
        url: '/file/attachment/upload',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: params,
        onUploadProgress
    })
}

export function uploadFileVideo(params, onUploadProgress) {
    return request({
        url: '/file/attachment/upload',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: params,
        onUploadProgress
    })
}

export function uploadFileImg(params) {
    return request({
        url: '/file/attachment/upload/open',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: params,
    })
}

export function removeAttachmentById(attId) {
    return request.delete(`/file/attachment?ids[]=${attId}`)
        .then((res) => {
            return Promise.resolve(res)
        })
}

export function downloadAttFile(attId) {
    return exportFile(`/file/attachment/download`, [attId]);
}

export function getCountryByMarketId(marketId) {
  return request.get(`/base/market/${marketId}/countryCode`, )
    .then((res) => res.data)
}

// 固定任务栏
export function setFixed(tabList) {
  return Cookies.set("fixedTab", tabList);
  // return request.get(`/base/market/${marketId}/countryCode`, )
  //   .then((res) => res.data)
}
// 获取固定任务栏列表
export function getFixed() {
  return Cookies.get("fixedTab");
  // return request.get(`/base/market/${marketId}/countryCode`, )
  //   .then((res) => res.data)
}

/**
 * 添加视图
 * @param params body
 * @returns {Promise<AxiosResponse<any>>}
 */
export const postAddView = params => {
    return request.post(`${PREFIX_URL}/base/customView/add`, params).then(res => res.data)
};

/**
 * 编辑视图
 * @param params body
 * @returns {Promise<AxiosResponse<any>>}
 */
export const putEditView = params => {
    return request.put(`${PREFIX_URL}/base/customView`, params).then(res => res.data)
};

export const setDefaultView = params => {
    return request.put(`${PREFIX_URL}/base/customView/updateSelect`, params)
};

/**
 * 视图列表
 * @param module 视图模块
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getViewList = module => {
    return request.get(`${PREFIX_URL}/base/customView/list/${module}`).then(res => res.data)
};

/**
 * 删除视图
 * @param id 视图id
 * @returns {Promise<AxiosResponse<any>>}
 */
export const deleteDelView = id => {
    return request.delete(`${PREFIX_URL}/base/customView/${id}`)
};

/**
 * 获取视图下拉数据
 * @param module 视图模块
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getViewOptions = module => {
    return request.get(`${PREFIX_URL}/base/customView/${module}/names`).then(res => res.data)
};

/**
 * 设置默认视图
 * @param id 视图id
 * @returns {Promise<AxiosResponse<any>>}
 */
export const putSetDefaultView = id => {
    return request.put(`${PREFIX_URL}/base/customView/${id}`).then(res => res.data)
};

/**
 * 查询视图参数
 * @param id 视图id
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getViewParams = id => {
    return request.get(`${PREFIX_URL}/base/customView/${id}`).then(res => res.data)
};

/**
 * 根据模块名和视图名查询视图参数
 * @param module 模块名
 * @param name 视图名
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getViewParamsByName = (module, name) => {
    return request.get(`${PREFIX_URL}/base/customView/${module}/${name}`).then(res => res.data)
}

// 打标 获取全部可用标签
export function getActiveTag(params){
    return request.get(`/crm/tag/getActiveTag`,{params})
    .then((res)=>{
      return Promise.resolve(res.data)
    })
}
// 打标 保存关联信息
export function saveTagToRelation(params){
    return request.post(`/crm/tag/saveTagToRelation`,params)
    .then((res)=>{
        return Promise.resolve(res.data)
    })
}
// 订单多商品打标
export function saveTagToListing(params){
    return request.post(`/crm/tag/saveTagToListing`,params)
    .then((res)=>{
        return Promise.resolve(res.data)
    })
}

export function getRemainingMail(params){
    return request.get(`/defaults/orderDeductionInfo/getRemainingMail`,params)
    .then((res)=>{
        return Promise.resolve(res.data)
    })
}

// 根据业务类型、id查询自定打印内容
export function queryCustomPrint(params) {
    return request.post(`/base/customPrint/queryByBiz`,params)
    .then((res)=>{
        return Promise.resolve(res.data)
    })
}

// 保存自定打印内容
export function saveCustomPrint(params) {
    return request.post(`/base/customPrint/saveUpdate`,params)
    .then((res)=>{
        return Promise.resolve(res.data)
    })
}

// 获取选择的自定义打印商品列表
export function getPrintSimpleListings(params) {
    return request.post(`/operation/listing/printSimpleListings`,params)
    .then((res)=>{
        return Promise.resolve(res.data)
    })
}
